export const CONSENT_CATEGORIES = {
  CAT_NECESSARY: 'necessary',
  CAT_ANALYTICS: 'analytics',
  CAT_ADVERTISEMENT: 'advertisement',
  CAT_FUNCTIONALITY: 'functionality',
  CAT_SECURITY: 'security',
}

export const CONSENT_SERVICES = {
  SERVICE_AD_STORAGE: 'ad_storage',
  SERVICE_AD_USER_DATA: 'ad_user_data',
  SERVICE_AD_PERSONALIZATION: 'ad_personalization',
  SERVICE_ANALYTICS_STORAGE: 'analytics_storage',
  SERVICE_FUNCTIONALITY_STORAGE: 'functionality_storage',
  SERVICE_PERSONALIZATION_STORAGE: 'personalization_storage',
  SERVICE_SECURITY_STORAGE: 'security_storage',
}
